import {loading, stopLoading} from "../../helpers/loading";
import {createGrid} from "../../helpers/grids/grids";
import {displayLocalValidationError} from "../../helpers/forms/validationErrors/utils";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {isArray} from "lodash";

function initPublicAuditionChooseRolesIndex() {

	// Setup submit button
	const submitButton = document.querySelector('.continue-button')
	submitButton.addEventListener('click', handleContinueRequest)

	// Retrieve roles
	const rolesGridRoute = document.querySelector('input[name="roles_grid_route"]').value;

	// Load initial roles
	let selectedRoles = JSON.parse(document.querySelector('input[name="selected_roles"]').value);

	if (isArray(selectedRoles)) {
		// Fix wrong init
		selectedRoles = {};
	}

	// Setup selected roles label
	const selectedRolesContainer = document.querySelector('.selected-roles-container');

	const clearAllButton = document.querySelector('.clear-all-button');
	clearAllButton.addEventListener('click', () => {
		selectedRoles = {};

		grid.api.redrawRows();
		renderSelectedRolesUpdate();
	})

	// Setup grid
	const grid = createGrid(
		document.querySelector('.roles-grid'),
		{
			columnDefs: [
				{
					field: "role",
					headerName: 'Role',
					sortable: true,
					sort: 'asc',
				},
			],
			// Get all roles in one request
			pagination: false,
			cacheBlockSize: 1000,
			paginationPageSize: 200,

			_rowName: 'Roles',
			rowClass: 'cursor-pointer',

			onRowClicked(event) {
				// noinspection JSUnresolvedReference
				const roleId = event.data.public_id;

				// Toggle selected role
				if (selectedRoles[roleId]) {
					delete selectedRoles[roleId];
				} else {
					selectedRoles[roleId] = {
						role_id: roleId,
					};
				}

				grid.api.redrawRows();

				renderSelectedRolesUpdate();
			},
			getRowClass(params) {
				// noinspection JSUnresolvedReference
				const roleId = params.data.public_id;

				return selectedRoles[roleId] ? 'selected' : '';
			}
		},
		rolesGridRoute
	)

	// First render
	renderSelectedRolesUpdate();

	/** Methods */

	function handleContinueRequest() {
		const rolesCount = Object.keys(selectedRoles).length;
		if (rolesCount < 1) {
			displayLocalValidationError(document.body, 'roles', 'You must select at least one role');

			return;
		}

		loading();

		Axios.post(submitButton.dataset.route, {
			roles: selectedRoles,
		})
			.then(response => {
				setTimeout(() => {
					// Show loading again
					loading();

					// Redirect to next step
					// noinspection JSUnresolvedReference
					window.location.href = response.data.redirectUrl;
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)

	}

	function renderSelectedRolesUpdate() {
		const rolesCount = Object.keys(selectedRoles).length;
		selectedRolesContainer.innerText = `Selected ${rolesCount} ${rolesCount === 1 ? 'Role' : 'Roles'}`;
	}
}

export {
	initPublicAuditionChooseRolesIndex
}
